import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const words = ["Finance.", "Futures.", "Ambition.", "Growth.", "Tandm."];

export default function TandmPreloader({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [dimension, setDimension] = useState({ width: 0, height: 0 });
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    setDimension({ width: window.innerWidth, height: window.innerHeight });
  }, []);

  useEffect(() => {
    if (index === words.length - 1) {
      setTimeout(() => {
        setIsExiting(true);
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 1000);
      }, 900);
      return;
    }
    setTimeout(() => {
      setIndex(index + 1);
    }, index === 0 ? 800 : 180);
  }, [index, onComplete]);

  const w = dimension.width;
  const h = dimension.height;
  const initialPath = "M0 0 L" + w + " 0 L" + w + " " + h + " Q" + (w / 2) + " " + (h + 300) + " 0 " + h + " L0 0";
  const targetPath = "M0 0 L" + w + " 0 L" + w + " " + h + " Q" + (w / 2) + " " + h + " 0 " + h + " L0 0";

  const slideUp = {
    initial: { top: 0 },
    exit: {
      top: "-100vh",
      transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: 0.2 },
    },
  };

  const fadeIn = {
    initial: { opacity: 0 },
    enter: {
      opacity: 1,
      transition: { duration: 0.6, delay: 0.1 },
    },
  };

  const curve = {
    initial: {
      d: initialPath,
      transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] },
    },
    exit: {
      d: targetPath,
      transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.3 },
    },
  };

  const containerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--tandm-gradient-hero-dark)",
    zIndex: 99999,
    fontFamily: "var(--tandm-font-display)",
  };

  const textStyle = {
    display: "flex",
    alignItems: "center",
    color: index === words.length - 1 ? "var(--tandm-accent-hot)" : "var(--tandm-on-dark)",
    fontSize: "clamp(2rem, 6vw, 4rem)",
    fontWeight: 500,
    position: "absolute",
    zIndex: 10,
    letterSpacing: "-0.03em",
  };

  const dotStyle = {
    display: "block",
    width: "10px",
    height: "10px",
    backgroundColor: "var(--tandm-accent-hot)",
    borderRadius: "50%",
    marginRight: "14px",
    flexShrink: 0,
  };

  const svgStyle = {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "calc(100% + 300px)",
  };

  return (
    <motion.div
      variants={slideUp}
      initial="initial"
      animate={isExiting ? "exit" : "initial"}
      style={containerStyle}
    >
      {dimension.width > 0 && (
        <>
          <motion.p
            key={index}
            variants={fadeIn}
            initial="initial"
            animate="enter"
            style={textStyle}
          >
            <span style={dotStyle} />
            {words[index]}
          </motion.p>
          <svg style={svgStyle}>
            <motion.path
              variants={curve}
              initial="initial"
              animate={isExiting ? "exit" : "initial"}
              style={{ fill: "var(--tandm-surface-dark-elevated)" }}
            />
          </svg>
        </>
      )}
    </motion.div>
  );
}
